




import Base from './Base.vue';
import { RozsahDate } from '../constants';
import Inventorydashboard from './InventoryDashboard.vue';

export default Base.extend({
	name: 'OdpisPP',
	components: {
		BaseFilterSestav: Base,
		Inventorydashboard,
	},
	created() {
		this.RozsahDate = RozsahDate.casVcera;
	},
});
